module.exports = __webpack_public_path__ + "images/category_lp/furniture/main-bg_e42ccb69e59f3eb1ab3d2d198597a23f.jpg";